/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDocumentDto } from '../../models/admin-document-dto';
import { UpdateAdminDocumentDto } from '../../models/update-admin-document-dto';

export interface AdminDocumentControllerUpdate$Params {
  id: string;
      body: UpdateAdminDocumentDto
}

export function adminDocumentControllerUpdate(http: HttpClient, rootUrl: string, params: AdminDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDocumentDto>;
    })
  );
}

adminDocumentControllerUpdate.PATH = '/api/adminDocument/{id}';
